/**
 * Format postal code to XXX-XXXX format
 * @param value - The postal code value to format
 * @returns Formatted postal code string
 */
export const formatPostalCode = (value: string): string => {
  if (!value) return '';

  // Remove all non-digit characters
  const digitsOnly = value.replace(/\D/g, '');

  // Format as XXX-XXXX
  let formatted = digitsOnly;
  if (digitsOnly.length > 3) {
    formatted = `${digitsOnly.slice(0, 3)}-${digitsOnly.slice(3, 7)}`;
  }

  return formatted;
};
